import { defineMessages } from 'react-intl';

export const shipmentDetailsSectionMessages = defineMessages({
  sectionTitle: {
    defaultMessage: 'Shipment Details',
    id: '0HszZD',
    description: 'Title of the shipment details card in the freight details view',
  },
  shipFromTitle: {
    defaultMessage: 'Ship From Location',
    id: '54B8PD',
    description: 'Column heading for the origin address of a freight shipment',
  },
  shipToTitle: {
    defaultMessage: 'Ship To Location',
    id: 'FRLwuq',
    description: 'Column heading for the destination address of a freight shipment',
  },
  emptyAddress: {
    defaultMessage: 'No address available',
    id: 'C6nuv1',
    description: 'Empty state shown when a freight shipment address is missing',
  },
  pickupServicesTitle: {
    defaultMessage: 'Pickup Services',
    id: 'ITJ7Ie',
    description: 'Heading for the pickup accessorial service tags',
  },
  deliveryServicesTitle: {
    defaultMessage: 'Delivery Services',
    id: '7nklCJ',
    description: 'Heading for the delivery accessorial service tags',
  },
  tradeshowLine: {
    defaultMessage: 'Tradeshow: {name} • Booth: {booth}',
    id: 'GowpiD',
    description: 'Tradeshow name and booth number shown below the Tradeshow Pickup/Delivery service tag',
  },
  pickupWindowTitle: {
    defaultMessage: 'Pickup Window',
    id: 'lrAQJ2',
    description: 'Heading for the pickup time window section in freight shipment details',
  },
  pickupWindowRange: {
    defaultMessage: 'Between {start} - {end}{tz} on {date}',
    id: 'O9G24P',
    description:
      'Formatted pickup time window, e.g. "Between 9:00 AM - 5:00 PM CST on Monday, June 1, 2026"; {tz} is a space-prefixed timezone abbreviation like " CST" or empty string',
  },
  pickupNumberLabel: {
    defaultMessage: 'Pickup number: {number}',
    id: '+NBcki',
    description: 'Pickup confirmation number displayed in the Pickup Window section',
  },
  pickupInstructionsTitle: {
    defaultMessage: 'Pickup Instructions',
    id: '3zK0Bg',
    description: 'Heading for special pickup instructions in freight shipment details',
  },
  deliveryInstructionsTitle: {
    defaultMessage: 'Delivery Instructions',
    id: 'Cn9VoZ',
    description: 'Heading for special delivery instructions in freight shipment details',
  },
  handlingInstructionsTitle: {
    defaultMessage: 'Handling Instructions',
    id: 'ITpJs7',
    description: 'Heading for special handling instructions in freight shipment details',
  },
});
